/**
 * @generated SignedSource<<4ff3675524c2f7c21ed8c332b9838c06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTaxExemption_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutHelpers_buyer" | "taxExemptHelpers_buyer">;
  readonly " $fragmentType": "CheckoutTaxExemption_buyer";
};
export type CheckoutTaxExemption_buyer$key = {
  readonly " $data"?: CheckoutTaxExemption_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemption_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTaxExemption_buyer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "taxExemptHelpers_buyer",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeTaxDocumentation",
              "kind": "LinkedField",
              "name": "taxDocumentation",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TradeStateDocument",
                  "kind": "LinkedField",
                  "name": "stateDocuments",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "expirationDate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutHelpers_buyer",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "partialAddressCheckoutEligibility",
              "variableName": "partialAddressCheckoutEligibility"
            }
          ],
          "concreteType": "AddressBook",
          "kind": "LinkedField",
          "name": "addressBook",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Address",
              "kind": "LinkedField",
              "name": "addressList",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayState",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "kind": "RootArgument",
          "name": "partialAddressCheckoutEligibility"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "98ea1ce15da7777b0d3136bc74e22154";

export default node;
